export const generateHMAC = async (key: string) => {
  const encoder = new TextEncoder();
  const payload = "sha384";
  const encodedKey = encoder.encode(key);
  const encodedPayload = encoder.encode(payload);
  const base64Payload = btoa(Array.from(new Uint8Array(encodedPayload)).map(byte => String.fromCharCode(byte)).join(''));

  // Web Crypto API를 사용해 키를 가져옵니다.
  const cryptoKey = await window.crypto.subtle.importKey(
    "raw",
    encodedKey,
    { name: "HMAC", hash: { name: "SHA-384" } },
    false,
    ["sign"]
  );

  // HMAC을 계산합니다.
  const signature = await window.crypto.subtle.sign(
    "HMAC",
    cryptoKey,
    encoder.encode(base64Payload)
  );

  // 결과를 Base64 문자열로 변환합니다.
  return btoa(Array.from(new Uint8Array(signature)).map(byte => String.fromCharCode(byte)).join(''));
};

export const base64Encode = (plainText: string) => {
  return btoa(
    encodeURIComponent(plainText).replace(/%([0-9A-F]{2})/g, (match, p1) =>
      String.fromCharCode(parseInt(p1, 16))
    )
  );
};

export const base64Decode = (encodedText: string) => {
  return decodeURIComponent(
    Array.from(atob(encodedText))
      .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
      .join("")
  );
};
